import gsap from "gsap";

function menuButton() {
  // Add needed classes to the menu - ex. current-page-ancestor
  let activeMenuItem = document.querySelector(".current-page-item");

  if (activeMenuItem) {
    activeMenuItem.parentNode?.parentNode?.classList.add(
      "current-page-ancestor"
    );
  }

  const hamburgerWrapper = document.querySelector(".hamburger-menu-wrapper");
  const hamburgerMenu = document.querySelector(".hamburger-menu");
  const hamburgerBG = document.querySelector(".hamburger-menu-bg");

  const menus = document.querySelector(".top-nav .menus");
  const subMenus = document.querySelectorAll(".top-nav .menus .sub-menu-wrap");
  const mainMenuItems = document.querySelectorAll(
    ".top-nav .menus #main-menu > li.menu-item "
  );
  const hasChildren = document.querySelectorAll(
    ".top-nav .menus #main-menu .menu-item-has-children > a"
  );
  const hasNoChildren = document.querySelectorAll(
    ".top-nav .menus .menu-item:not(.menu-item-has-children) > a"
  );
  const menuContainer = document.querySelector(".top-nav-menu-container");
  const backLink = document.querySelectorAll(
    ".top-nav-menu-container .back-menu"
  );

  let isMobile = false;
  if ($(window).width() < 768) {
    isMobile = true;
  }

  gsap.set(subMenus, {
    visibility: "visible",
    height: 0,
    opacity: 0,
    pointerEvents: "none",
  });

  // Open and close menu - Hamburger clicks.
  hamburgerWrapper.addEventListener(
    "click",
    function () {
      hamburgerWrapper.classList.toggle("is-active");
      hamburgerMenu.classList.toggle("active");

      if (hamburgerWrapper.classList.contains("is-active")) {
        // Opening the menu
        menuContainer.classList.add("open");

        if (!isMobile) {
          let tl = gsap.timeline();
          tl.to(menus, { x: 0 }).fromTo(
            mainMenuItems,
            { alpha: 0, y: 50 },
            { alpha: 1, y: 0, stagger: 0.1 }
          );
        } else {
          let tl = gsap.timeline();
          tl.to(menus, { x: 0 }).fromTo(
            mainMenuItems,
            { alpha: 0 },
            { alpha: 1, stagger: 0.1 }
          );
        }


        // Open submenu if in current subpage.
        mainMenuItems.forEach((menuItem) => {
          if (menuItem.classList.contains("current_page_ancestor")) {
            menuItem.querySelector("a").click();
          }
        });
      } else {
        // Closing the menu
        menuContainer.classList.remove("open");

        let tl = gsap.timeline();
        tl.to(menus, { x: isMobile ? "100vw" : "70vw" });
      }
    },
    false
  );

  // Open and close sub-menu - Menu item with children clicks.
  hasChildren.forEach((menuItem) => {
    menuItem.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        
        const subMenu = menuItem
          .closest(".menu-item")
          .querySelector(".sub-menu-wrap");
        const subMenuItems = subMenu.querySelectorAll("li.menu-item");

        
        // Opening the sub-menu
        let tl = gsap.timeline();
        
        //reset
        var allSubMenus = document.querySelectorAll('.sub-menu-wrap');
        allSubMenus.forEach((item) => {
          if(item == subMenu) {
            return
          }          
          if(item.classList.contains('is-active')) {
            tl.to(item, {
              visibility: "visible",
              height: 0,
              opacity: 0,
              pointerEvents: "none",
            });
          }
          item.classList.remove('is-active');
        })

        //current item
        if(!subMenu.classList.contains('is-active')) {
          subMenu.classList.add('is-active');
          tl.to(subMenu, {
            visibility: "visible",
            height: "auto",
            opacity: 1,
            pointerEvents: "auto",
          })
        } else {
          subMenu.classList.remove('is-active');
          tl.to(subMenu, {
            visibility: "visible",
            height: 0,
            opacity: 0,
            pointerEvents: "none",
          });
        }

        if (isMobile) {
          if (subMenu.classList.contains("is-active")) {
            tl.to(subMenu, { x: "0vw", visibility: 'visible', opacity: 1, pointerEvents: 'auto' }, ">+=1.2")
              .fromTo(
                subMenuItems,
                { alpha: 0, y: 50 },
                { alpha: 1, y: 0, stagger: 0.1 },
                "<+=0.4"
              )
          } else {
            tl.to(subMenu, { x: "100vw", visibility: 'hidden', opacity: 0, pointerEvents: 'none' }, "<")
          }
        } 
        // else {
        //   if (subMenu.classList.contains("is-active")) {
        //     tl.to(subMenu, {
        //       visibility: "visible",
        //       height: "auto",
        //       opacity: 1,
        //       pointerEvents: "auto",
        //     });
        //   } else {
        //     tl.to(subMenu, {
        //       visibility: "visible",
        //       height: 0,
        //       opacity: 0,
        //       pointerEvents: "none",
        //     });
        //   }
          //.fromTo( subMenuItems, { alpha: 0, y: 50 }, { alpha:1, y: 0, stagger: 0.1 }, '<+0.4' )
        // }
      },
      false
    );
  });

  // Close menu before loading a new page - Menu item clicks.
  hasNoChildren.forEach((menuItem) => {
    menuItem.addEventListener(
      "click",
      function (e) {
        // Closing the menu before load (if open in same page)
        if (!e.ctrlKey) {
          gsap.to("body", { alpha: 0, duration: 0.4 });
        }
      },
      false
    );
  });

  // Go back link on menu mobile version.
  backLink.forEach((back) => {
    back.addEventListener("click", function () {
      gsap.to(subMenus, { x: "100vw", ease: "power2" });
      back.closest('.sub-menu-wrap').classList.remove("is-active");
    });
  });


   
}

export default menuButton;
